module.exports = __webpack_public_path__ + "img/introducePageSeven_show_one.190a323f.jpg";